import ReactDOM from 'react-dom';
import React from 'react';

const escapeAttributeValue = (value: string) =>
  value.replaceAll(/\\/g, String.raw`\\`).replace(/"/g, String.raw`\"`);

const AEMComponentPortal = ({
  selector,
  children,
}: {
  selector: string;
  children: React.ReactNode;
}) => {
  const elem = document.querySelector(`[data-react-component="${escapeAttributeValue(selector)}"]`);

  if (elem) {
    // Only render children if mounting point is available
    return ReactDOM.createPortal(children, elem);
  }

  return null;
};

export default AEMComponentPortal;
